module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAEaCAYAAAAYH9ezAAAAsUlEQVR4nO3WQQrCUAwA0fniBb2oHrEiZC3Cp9jFm32H0A5pVs/jaIPbzsMf1rE3wP4EBHVfr75+huPROvUl6uAKAh0QpAOCQQcE/dLB6RPowH8hHVxEoAOCdEAw6IAgdyLBYB8QpAOCQQcE6YBgcCcSZB8QDDogSAcEgw4IcicSDPYBQTogGHRAkA4IBnciQfYBwaADgnRAMOiAIHciwWAfEKQDgkEHBOmAYPjznVi9AR08zWObRAGlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/rightScale.png
// module id = 9+ze
// module chunks = 2